/* import __COLOCATED_TEMPLATE__ from './setup-instructions.hbs'; */
/* RESPONSIBLE TEAM: team-omni */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLElement;
  Args: {
    shouldShowInstructions?: boolean;
  };
}

const SetupInstructions = templateOnlyComponent<Signature>();
export default SetupInstructions;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::Slack::SetupInstructions': typeof SetupInstructions;
    'new-settings/channels/slack/setup-instructions': typeof SetupInstructions;
  }
}
